import React from 'react';
import Chart from '../components/Chart'
import AutoComplete from '../components/AutoComplete';

        const Asthma = (props) => {

            var sorted = props.testdata.sort(function(a,b) {
                return b.reports - a.reports
            }).slice(0,10);

    return (
        <div>
            <div className="white-box asthma">
                <h1>Asthma triggers</h1>
                <div className="detailsection">
                    <p>Mold, chronic moisture, dust, and rodent and cockroach droppings inside schools can be signs of neglected maintenance and lack of concern. For students with allergies and asthma, spending hours inside the district&rsquo;s poorly ventilated, filthy and fatigued school buildings expose them to asthma attacks.</p>
                    <p>During an attack, the muscles around a child&rsquo;s airways rapidly become swollen and inflamed, causing labored breathing, coughing and anxiety. Medication can help, especially when administered quickly, but a severe asthma attack can be life-threatening.</p>
                    <p>Unchecked plumbing leaks can spread of mold and put asthmatics at risk. Mold spores can quickly spread in unseen areas above drop ceilings, under rugs, inside cabinets, or behind drywalls. Mold and other signs of moisture are one of the most frequent problems district environmental workers find. Maintenance records show these problems were noted over 1,000 times in 2016.</p>
                    <p>Problems worsen for students and staff when old and poorly maintained ventilation systems cannot circulate fresh air and keep down humidity, a problem in many schools.</p>
                    <p>Rodents and cockroaches leave behind dander and droppings, which pose an asthma hazard for some students. School cafeterias are often the source of rodent and insect infestations if kitchens are not kept clean and dry. Unapproved cleaning products and aromatic plants can also exacerbate asthma. For asthma-related concerns, contact the school district&rsquo;s <a href="https://www.philasd.org/capitalprograms/programsservices/environmental/environmental-programs-services/">Department of Environmental Programs</a> &amp; Services at 215-400-4730.</p>
                    <hr/>
                    <h3>Schools with the highest number of reports of potential asthma triggers</h3>
                    <Chart newdata={sorted} charttype="asthma" chartlabel="Number of reports"/>
                </div>
            </div>
{/*
            <hr />
            <div className="detailsection">


            </div> */}

            <div id="inputwrapper">
                <AutoComplete getUrl={props.match} data={props.data} placeholder="Search for another school..." />
            </div>
        </div>
        );
}

export default Asthma;



// WEBPACK FOOTER //
// ./src/routes/Asthma.js